module.exports = __webpack_public_path__ + "img/qipao.171ea142.png";